export interface WeatherForecast {
  date: string // ISO date, e.g. "2026-08-13"
  temperatureC: number
  temperatureF: number
  summary: string | null
}

// Empty base => relative URLs. In production CloudFront serves /api/* from the
// same origin; in dev Vite proxies /api to the backend (see vite.config.ts).
const API_BASE = import.meta.env.VITE_API_BASE_URL ?? ''

// Carries the status code, so a caller can tell "not signed in" from "broken".
// App.tsx needs that distinction: with no /api/me, a 401 here is what tells it to
// show the login screen.
export class ApiError extends Error {
  constructor(readonly status: number) {
    super(`Weather API returned ${status}`)
    this.name = 'ApiError'
  }
}

export async function getForecast(days = 7): Promise<WeatherForecast[]> {
  // credentials: 'include' because this request doubles as the sign-in check —
  // the default of 'same-origin' would drop the cookie once VITE_API_BASE_URL
  // points somewhere else, and every call would 401.
  const res = await fetch(`${API_BASE}/api/weatherforecast/${days}`, { credentials: 'include' })
  if (!res.ok) {
    throw new ApiError(res.status)
  }
  return (await res.json()) as WeatherForecast[]
}
